'use client';

import { GroupHelpCenter } from '@utils/strapiDoc.util';

import { Item } from './Item/Item';
import css from './ListingAcademySection.module.css';

export type ListingAcademySectionProps = {
  groupsHelpCenter: GroupHelpCenter[];
  locale: string;
};

const getCtasFromGroup = (doc: GroupHelpCenter) => {
  const firstDoc = doc.attributes.help_pages.data[0];
  const numberOfDocs = doc.attributes.help_pages.data.length;

  const hasOnlyOneDoc = numberOfDocs === 1;
  const hasTwoDocs = numberOfDocs === 2;

  if (hasOnlyOneDoc) {
    return [
      {
        text: firstDoc.attributes.title,
        link: `/help-center/${doc.attributes.slug}/${firstDoc.attributes.slug}`,
      },
    ];
  }
  if (hasTwoDocs) {
    const secondDoc = doc.attributes.help_pages.data[1];
    return [
      {
        text: firstDoc.attributes.title,
        link: `/help-center/${doc.attributes.slug}/${firstDoc.attributes.slug}`,
      },
      {
        text: secondDoc.attributes.title,
        link: `/help-center/${doc.attributes.slug}/${secondDoc.attributes.slug}`,
      },
    ];
  }

  return [
    {
      text: firstDoc?.attributes.title,
      link: `/help-center/${doc.attributes.slug}/${firstDoc?.attributes.slug}`,
    },
    {
      text: `Voir les ${numberOfDocs - 1} autres articles`,
      link: `/help-center/${doc.attributes.slug}/${firstDoc?.attributes.slug}`,
    },
  ];
};

export const ListingAcademySection = ({
  groupsHelpCenter,
}: ListingAcademySectionProps) => {
  return (
    <div className={css.container}>
      {groupsHelpCenter.map((group, index) => (
        <Item
          key={index}
          title={group.attributes.title}
          ctas={getCtasFromGroup(group)}
          image={group.attributes.thumb.data[0].attributes.url}
        />
      ))}
    </div>
  );
};
